// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n2-0";
export var animationContainer = "_n2-1";
export var itemPrice = "_n2-a";
export var itemizedContent = "_n2-9";
export var itemizedHeader = "_n2-7";
export var itemizedRow = "_n2-8";
export var itemizedSection = "_n2-6";
export var modalContent = "_n2-2";
export var orderName = "_n2-3";
export var refundOption = "_n2-4";
export var refundOptionsContainer = "_n2-5";
export var shippingLabel = "_n2-b";
export var totalRow = "_n2-c";